var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 39C23.4 39 23 39.4 23 40V42C23 42.6 23.4 43 24 43C24.6 43 25 42.6 25 42V40C25 39.4 24.6 39 24 39Z",
    fill: "#6B47F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 31H38C38.6 31 39 30.6 39 30C39 29.4 38.6 29 38 29H28C27.4 29 27 29.4 27 30C27 30.6 27.4 31 28 31Z",
    fill: "#6B47F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 35H40C40.6 35 41 34.6 41 34C41 33.4 40.6 33 40 33H28C27.4 33 27 33.4 27 34C27 34.6 27.4 35 28 35Z",
    fill: "#6B47F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39H41C41.6 39 42 38.6 42 38C42 37.4 41.6 37 41 37H28C27.4 37 27 37.4 27 38C27 38.6 27.4 39 28 39Z",
    fill: "#6B47F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41H28C27.4 41 27 41.4 27 42C27 42.6 27.4 43 28 43H42C42.6 43 43 42.6 43 42C43 41.4 42.6 41 42 41Z",
    fill: "#6B47F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45H28C27.4 45 27 45.4 27 46C27 46.6 27.4 47 28 47H42C42.6 47 43 46.6 43 46C43 45.4 42.6 45 42 45Z",
    fill: "#6B47F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42 49H28C27.4 49 27 49.4 27 50C27 50.6 27.4 51 28 51H42C42.6 51 43 50.6 43 50C43 49.4 42.6 49 42 49Z",
    fill: "#6B47F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61H60C59.4 61 59 61.4 59 62C59 62.6 59.4 63 60 63H62C62.6 63 63 62.6 63 62C63 61.4 62.6 61 62 61Z",
    fill: "#6B47F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60.9998H25V45.7998C25 45.1998 24.6 44.7998 24 44.7998C23.4 44.7998 23 45.1998 23 45.7998V60.9998H22C21.4 60.9998 21 61.3998 21 61.9998C21 62.5998 21.4 62.9998 22 62.9998H38C38.6 62.9998 39 62.5998 39 61.9998C39 61.3998 38.6 60.9998 38 60.9998Z",
    fill: "#6B47F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56 61H46.6C46.8 58.4 47 55.7 47 53C47 52.4 46.6 52 46 52C45.4 52 45 52.4 45 53C45 55.7 44.9 58.4 44.6 61H42C41.4 61 41 61.4 41 62C41 62.6 41.4 63 42 63H56C56.6 63 57 62.6 57 62C57 61.4 56.6 61 56 61Z",
    fill: "#6B47F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18 61H2C1.4 61 1 61.4 1 62C1 62.6 1.4 63 2 63H18C18.6 63 19 62.6 19 62C19 61.4 18.6 61 18 61Z",
    fill: "#6B47F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43 54C43 53.4 42.6 53 42 53H28C27.4 53 27 53.4 27 54C27 54.6 27.4 55 28 55H42C42.6 55 43 54.6 43 54Z",
    fill: "#6B47F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57C27.4 57 27 57.4 27 58C27 58.6 27.4 59 28 59H41C41.6 59 42 58.6 42 58C42 57.4 41.6 57 41 57H28Z",
    fill: "#6B47F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50 11H60C61.7 11 63 9.7 63 8C63 6.7 62.1 5.5 60.9 5.1C60.5 2.8 58.5 1 56 1C54.2 1 52.5 2 51.6 3.6C51.3 4.1 51.5 4.7 52 5C52.5 5.3 53.1 5.1 53.4 4.6C53.9 3.6 54.9 3 56 3C57.7 3 59 4.3 59 6C59 6.6 59.4 7 60 7C60.6 7 61 7.4 61 8C61 8.6 60.6 9 60 9H50C49.4 9 49 8.6 49 8C49 7.4 49.4 7 50 7C50.6 7 51 6.6 51 6C51 5.4 50.6 5 50 5C48.3 5 47 6.3 47 8C47 9.7 48.3 11 50 11Z",
    fill: "#6B47F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11H14C15.7 11 17 9.7 17 8C17 6.7 16.1 5.5 14.9 5.1C14.5 2.8 12.5 1 10 1C8.2 1 6.5 2 5.6 3.6C5.4 4.1 5.5 4.7 6 4.9C6.5 5.2 7.1 5 7.4 4.6C7.9 3.6 8.9 3 10 3C11.7 3 13 4.3 13 6C13 6.6 13.4 7 14 7C14.6 7 15 7.4 15 8C15 8.6 14.6 9 14 9H4C3.4 9 3 8.6 3 8C3 7.4 3.4 7 4 7C4.6 7 5 6.6 5 6C5 5.4 4.6 5 4 5C2.3 5 1 6.3 1 8C1 9.7 2.3 11 4 11Z",
    fill: "#6B47F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6.9C30.5 7.2 31.1 7 31.4 6.5C31.9 5.6 32.9 5 34 5C35.7 5 37 6.3 37 8C37 8.6 37.4 9 38 9C38.6 9 39 9.4 39 10C39 10.6 38.6 11 38 11C37.4 11 37 11.4 37 12C37 12.6 37.4 13 38 13C39.7 13 41 11.7 41 10C41 8.7 40.1 7.5 38.9 7.1C38.5 4.8 36.5 3 34 3C32.2 3 30.5 4 29.6 5.6C29.4 6.1 29.5 6.7 30 6.9V6.9Z",
    fill: "#6B47F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26C15 26.6 15.4 27 16 27H17.6L23 32.4V36C23 36.6 23.4 37 24 37C24.6 37 25 36.6 25 36V9C35.1 10 43.7 26.8 44.9 48.1C44.9 48.6 45.4 49 46 49C46.6 49 47 48.5 46.9 47.9C45.7 25.3 36.3 8 25 7V2C25 1.4 24.6 1 24 1C23.4 1 23 1.4 23 2V25H16C15.4 25 15 25.4 15 26ZM23 27V29.6L20.4 27H23Z",
    fill: "#6B47F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28 21.1001C27.4 21.1001 27 21.5001 27 22.1001V26.0001C27 26.6001 27.4 27.0001 28 27.0001H37.5C38.4 27.0001 38.6 25.9001 38.4 25.6001C35.8 18.8001 32.3 14.1001 28.4 12.1001C28.1 12.0001 27 12.1001 27 13.0001V18.0001C27 18.6001 27.4 19.0001 28 19.0001C28.6 19.0001 29 18.6001 29 18.0001V14.8001C31.6 16.8001 34.1 20.3001 36.1 25.0001H29V22.1001C29 21.6001 28.6 21.1001 28 21.1001Z",
    fill: "#6B47F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.86a57f501413e8274c5574256be8e483.svg";
export { ForwardRef as ReactComponent };